module.exports = __webpack_public_path__ + "static/media/trash_1.dbefbaba.svg";